import React from "react";
import { useNavigate } from "react-router-dom";
import { MdAccountCircle } from "react-icons/md";
import { useTranslation } from "react-i18next";

import { logout } from "../services/authService";
import { useBooking } from "../context/BookingContext";
import { useToken } from "../context/TokenContext";
import { toastEmitter } from "../utils/toastEmitter";

const LoginButton: React.FC = () => {
  const { t } = useTranslation();
  const { phoneNumber, countryPrefix, clearBookingInfo } = useBooking();
  const { loginToken, serviceToken, clearTokens } = useToken();
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate("/login");
  };

  const handleLogout = async () => {
    if (loginToken && serviceToken) {
      if (await logout({ loginToken, serviceToken })) {
        clearTokens();
        clearBookingInfo();
        toastEmitter.showToast(t('AuthLogoutSuccess'), "success");
      }
    } else {
      console.error("loginToken or serviceToken is null");
      toastEmitter.showToast(t('AuthLogoutError'), "error");
    }
  };

  return (
    <>
      {phoneNumber ? (
        <div className="flex items-center">
          <MdAccountCircle className="text-[#EC6707] text-2xl md:text-3xl" />
          <span className="inline text-gray-100 text-xs font-bold ml-1 md:text-sm">
            {t('AuthWelcome', { countryPrefix, phoneNumber })}
          </span>
          <button
            onClick={handleLogout}
            id={'logout-btn'}
            className="ml-2 md:ml-3 px-2 py-1 sm:px-3 md:px-4 md:py-1.5 bg-[#EC6707] rounded-full hover:bg-[#d55a06] font-bold text-black text-xs sm:text-sm"
          >
            {t('Logout')}
          </button>
        </div>
      ) : (
        <button
          onClick={handleLoginRedirect}
          id={'login-btn'}
          className="px-3 py-1.5 bg-[#EC6707] rounded-full hover:bg-[#d55a06] font-bold text-black text-xs sm:text-sm"
        >
          {t('Login')}
        </button>
      )}
    </>
  );
};

export default LoginButton;